import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { Chart, useChart } from 'react-jsx-highcharts';
import { adjustChartSize } from '../utils';

const BenchmarksChart = ({
    minWidth,
    loaded = false,
    marginBottom,
    marginLeft = 55,
    className,
    type,
    height,
    inverted,
    grouping,
}) => {
    const chartObject = useChart().object;
    const scrollablePlotArea = minWidth ? { scrollablePlotArea: { minWidth } } : {};
    const isSidenavSlim = useSelector(state => state.settings.isSidenavSlim);

    useEffect(() => {
        adjustChartSize(chartObject, 'reflow');
    }, [isSidenavSlim]);

    useEffect(() => {
        if (loaded) adjustChartSize(chartObject, 'redraw');
    }, [loaded]);

    return (
        <Chart
            type={type}
            className={className}
            marginLeft={marginLeft}
            marginRight={55}
            marginBottom={marginBottom}
            style={{ fontFamily: 'open-sans' }}
            height={height}
            inverted={inverted}
            grouping={grouping}
            {...scrollablePlotArea}
        />
    );
};

BenchmarksChart.propTypes = {
    minWidth: PropTypes.number,
    loaded: PropTypes.bool,
    marginBottom: PropTypes.number,
    marginLeft: PropTypes.number,
    className: PropTypes.string,
    type: PropTypes.string,
    height: PropTypes.number,
    inverted: PropTypes.bool,
    grouping: PropTypes.bool,
};

export default BenchmarksChart;
